import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './ai-study-helper.css'

const AIStudyHelper = (props) => {
  return (
    <div className="ai-study-helper-container1">
      <Helmet>
        <title>AI-Study-Helper - Super Sizzling Curlew</title>
        <meta
          property="og:title"
          content="AI-Study-Helper - Super Sizzling Curlew"
        />
        <link
          rel="canonical"
          href="https://super-sizzling-curlew-lvmy3i.teleporthq.site/ai-study-helper"
        />
      </Helmet>
      <Navigation
        text={
          <Fragment>
            <span className="ai-study-helper-text10">More</span>
          </Fragment>
        }
      ></Navigation>
      <section className="ai-hero-section">
        <div className="ai-hero-bg">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/30718607/13141992_540_360_30fps.mp4"
            className="ai-hero-video"
          ></video>
          <div className="ai-hero-overlay"></div>
        </div>
        <div className="ai-hero-container">
          <div className="ai-hero-content">
            <h1 className="hero-title">
              <span>
                {' '}
                Master Your Semester
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="ai-study-helper-thq-text-accent-elm">
                with SylliPlan
              </span>
            </h1>
            <p className="hero-subtitle">
              Upload your syllabus and let our AI transform it into a
              personalized daily study plan. Smart reminders, auto-generated
              flashcards, and data-driven recommendations at your fingertips.
            </p>
            <div className="ai-hero-actions">
              <a href="#try">
                <div className="btn btn-primary btn-lg">
                  <span>Try the AI Tool</span>
                </div>
              </a>
              <a href="#login">
                <div className="btn btn-lg btn-outline">
                  <span>Student Login</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="key-features-section">
        <div className="key-features-container">
          <div className="key-features-header">
            <h2 className="section-title">Smart Study Tools</h2>
            <p className="section-content">
              Everything you need to stay ahead of your curriculum and ace your
              exams.
            </p>
          </div>
          <div className="key-features-grid">
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-brain"
                >
                  <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                  <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                  <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                  <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                  <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                  <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">AI Recommendations</h3>
              <p className="section-content">
                Personalized study suggestions based on your syllabus difficulty
                and deadlines.
              </p>
            </div>
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar"
                >
                  <path d="M8 2v4m8-4v4"></path>
                  <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                  <path d="M3 10h18"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Smart Reminders</h3>
              <p className="section-content">
                Adaptive scheduling that adjusts to your pace and ensures you
                never miss a task.
              </p>
            </div>
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-wallet-cards"
                >
                  <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                  <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Auto-Flashcards</h3>
              <p className="section-content">
                Instantly generate high-quality flashcards from your uploaded
                lecture notes and syllabus.
              </p>
            </div>
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chart-line"
                >
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  <path d="m19 9l-5 5l-4-4l-3 3"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Progress Tracking</h3>
              <p className="section-content">
                Visual analytics to monitor your learning journey and identify
                areas for improvement.
              </p>
            </div>
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-badge-check"
                >
                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Goal Setting</h3>
              <p className="section-content">
                Define your academic targets and let SylliPlan map out the exact
                path to reach them.
              </p>
            </div>
            <div className="ai-study-helper-feature-card">
              <div className="feature-icon-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-cloud-upload"
                >
                  <path d="M12 13v8m-8-6.101A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"></path>
                  <path d="m8 17l4-4l4 4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Syllabus Sync</h3>
              <p className="section-content">
                Cloud-based syncing ensures your study plan is always available
                across all your devices.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="how-it-works-section">
        <div className="how-it-works-container">
          <h2 className="section-title">Your Path to Success</h2>
          <div className="process-steps">
            <div className="ai-study-helper-step-item">
              <div className="ai-study-helper-step-number">
                <span>01</span>
              </div>
              <div className="step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-upload"
                >
                  <path d="M12 3v12m5-7l-5-5l-5 5m14 7v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Upload Syllabus</h3>
              <p className="section-content">
                Drag and drop your PDF or image syllabus into our secure AI
                engine.
              </p>
            </div>
            <div className="step-connector"></div>
            <div className="ai-study-helper-step-item">
              <div className="ai-study-helper-step-number">
                <span>02</span>
              </div>
              <div className="step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-brain-cog"
                >
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="m10.852 14.772l-.383.923m.383-6.467l-.383-.923m2.679 6.467l.382.924m.001-7.391l-.383.923m1.624 1.624l.923-.383m-.923 2.679l.923.383M17.598 6.5A3 3 0 1 0 12 5a3 3 0 0 0-5.63-1.446a3 3 0 0 0-.368 1.571a4 4 0 0 0-2.525 5.771"></path>
                  <path d="M17.998 5.125a4 4 0 0 1 2.525 5.771"></path>
                  <path d="M19.505 10.294a4 4 0 0 1-1.5 7.706"></path>
                  <path d="M4.032 17.483A4 4 0 0 0 11.464 20c.18-.311.892-.311 1.072 0a4 4 0 0 0 7.432-2.516"></path>
                  <path d="M4.5 10.291A4 4 0 0 0 6 18m.002-12.875a3 3 0 0 0 .4 1.375m2.826 4.352l-.923-.383m.923 2.679l-.923.383"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">AI Analysis</h3>
              <p className="section-content">
                Our AI extracts key dates, assignments, and topics to build your
                roadmap.
              </p>
            </div>
            <div className="step-connector"></div>
            <div className="ai-study-helper-step-item">
              <div className="ai-study-helper-step-number">
                <span>03</span>
              </div>
              <div className="step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar-days"
                >
                  <path d="M8 2v4m8-4v4"></path>
                  <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                  <path d="M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Get Your Plan</h3>
              <p className="section-content">
                Receive a semester daily plan with flashcards and smart study
                reminders.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="study-timeline-section">
        <div className="timeline-wrapper">
          <div className="timeline-header">
            <h2 className="section-title">Your Semester Roadmap</h2>
            <p className="section-content">
              A glimpse into your AI-generated daily study flow.
            </p>
          </div>
          <div className="timeline-scroll-container">
            <div className="timeline-horizontal">
              <div className="timeline-event">
                <div className="event-marker"></div>
                <div className="event-card">
                  <span className="event-date">Monday, Oct 02</span>
                  <h4 className="event-title">Intro to Microeconomics</h4>
                  <p className="event-desc">
                    Read Chapter 1-2. AI Flashcards generated.
                  </p>
                  <span className="event-tag">Reading</span>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker"></div>
                <div className="event-card">
                  <span className="event-date">Tuesday, Oct 03</span>
                  <h4 className="event-title">Math Quiz Prep</h4>
                  <p className="event-desc">
                    Practice Set 4. Reminder: Review formulas.
                  </p>
                  <span className="event-tag accent">Quiz</span>
                </div>
              </div>
              <div className="timeline-event featured">
                <div className="event-marker"></div>
                <div className="event-card">
                  <span className="event-date">Wednesday, Oct 04</span>
                  <h4 className="event-title">History Essay Due</h4>
                  <p className="event-desc">
                    Final proofreading and submission via portal.
                  </p>
                  <span className="event-tag primary">Deadline</span>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker"></div>
                <div className="event-card">
                  <span className="event-date">Thursday, Oct 05</span>
                  <h4 className="event-title">Physics Lab</h4>
                  <p className="event-desc">
                    Data analysis module. Review lab safety notes.
                  </p>
                  <span className="event-tag">Lab Work</span>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker"></div>
                <div className="event-card">
                  <span className="event-date">Friday, Oct 06</span>
                  <h4 className="event-title">Weekly Review</h4>
                  <p className="event-desc">
                    AI-curated summary of this week&apos;s key concepts.
                  </p>
                  <span className="event-tag secondary">Review</span>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker"></div>
                <div aria-hidden="true" className="event-card filler">
                  <span className="event-date">Saturday, Oct 07</span>
                  <h4 className="event-title">Rest &amp; Recharge</h4>
                  <p className="event-desc">
                    No study tasks scheduled today. Enjoy your break!
                  </p>
                  <span className="event-tag">Free Day</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="demo-video-section">
        <div className="demo-video-bg">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/12202017/12202017-hd_2048_1080_50fps.mp4"
            className="demo-video-media"
          ></video>
          <div className="demo-video-overlay"></div>
        </div>
        <div className="demo-video-content">
          <h2 className="hero-title">See SylliPlan in Action</h2>
          <p className="hero-subtitle">
            Watch how our AI turns a 20-page syllabus into a manageable daily
            checklist in under 60 seconds.
          </p>
          <div className="demo-video-actions">
            <button className="btn btn-accent btn-xl">Watch Full Demo</button>
            <button className="btn btn-primary btn-xl">Start Your Plan</button>
          </div>
        </div>
      </section>
      <section className="student-testimonials-section">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <h2 className="section-title">Student Success Stories</h2>
            <p className="section-content">
              Join thousands of students who have transformed their grades with
              SylliPlan.
            </p>
          </div>
          <div className="ai-study-helper-testimonials-grid">
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/5212687/pexels-photo-5212687.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Sarah J."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">Sarah Jenkins</h4>
                  <span className="student-major">Biology Major</span>
                </div>
              </div>
              <p className="section-content">
                &quot;SylliPlan completely saved my semester. Uploading my
                syllabus was so easy, and the daily tasks kept me from
                procrastinating.&quot;
              </p>
            </div>
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/9040286/pexels-photo-9040286.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Marcus T."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">Marcus Thompson</h4>
                  <span className="student-major">Engineering</span>
                </div>
              </div>
              <p className="section-content">
                &quot;The auto-generated flashcards are a game changer. I used
                to spend hours making them; now the AI does it perfectly in
                seconds.&quot;
              </p>
            </div>
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/9158999/pexels-photo-9158999.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Elena R."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">Elena Rodriguez</h4>
                  <span className="student-major">Law Student</span>
                </div>
              </div>
              <p className="section-content">
                &quot;The smart reminders are actually smart. They adapt if I
                fall behind, making sure I still hit my exam targets without
                burning out.&quot;
              </p>
            </div>
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/8199165/pexels-photo-8199165.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="David K."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">David Kim</h4>
                  <span className="student-major">Business Admin</span>
                </div>
              </div>
              <p className="section-content">
                &quot;I went from a 2.8 to a 3.6 GPA in one semester. The
                personalized study recommendations are like having a private
                tutor 24/7.&quot;
              </p>
            </div>
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/6266978/pexels-photo-6266978.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Aisha B."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">Aisha Bello</h4>
                  <span className="student-major">Pre-Med</span>
                </div>
              </div>
              <p className="section-content">
                &quot;Finally, a tool that understands how much work Pre-Med is.
                The timeline keeps all my lab reports and exams perfectly
                organized.&quot;
              </p>
            </div>
            <div className="ai-study-helper-testimonial-card">
              <div className="student-info">
                <img
                  src="https://images.pexels.com/photos/5530515/pexels-photo-5530515.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Liam O."
                  className="student-avatar"
                />
                <div>
                  <h4 className="student-name">Liam O&apos;Connor</h4>
                  <span className="student-major">Computer Science</span>
                </div>
              </div>
              <p className="section-content">
                &quot;The progress tracking keeps me motivated. Seeing my
                completion rate climb makes the hard work feel much more
                rewarding.&quot;
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="resources-cta-section">
        <div className="resources-container">
          <div className="resources-header">
            <h2 className="section-title">Ready to Ace Your Exams?</h2>
            <p className="section-content">
              Explore our free resources or start your AI-powered study journey
              today.
            </p>
          </div>
          <div className="resources-grid">
            <div className="resource-item">
              <div className="resource-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-cards"
                >
                  <path d="m3.604 7.197l7.138-3.109a.96.96 0 0 1 1.27.527l4.924 11.902a1 1 0 0 1-.514 1.304L9.285 20.93a.96.96 0 0 1-1.271-.527L3.09 8.5a1 1 0 0 1 .514-1.304zM15 4h1a1 1 0 0 1 1 1v3.5M20 6q.396.168.768.315a1 1 0 0 1 .53 1.311L19 13"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Sample Flashcards</h3>
              <p className="section-content">
                Download sample sets for common subjects like Biology,
                Psychology, and Calculus.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>View Samples</span>
                </div>
              </a>
            </div>
            <div className="resource-item">
              <div className="resource-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-file-chart-line"
                >
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5m-4 5l-3.5 3.5l-2-2L8 17"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Study Templates</h3>
              <p className="section-content">
                Proven frameworks for note-taking and syllabus organization to
                maximize retention.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Templates</span>
                </div>
              </a>
            </div>
            <div className="resource-item">
              <div className="resource-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-brain-circuit"
                >
                  <path d="M12 5a3 3 0 1 0-5.997.125a4 4 0 0 0-2.526 5.77a4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                  <path d="M9 13a4.5 4.5 0 0 0 3-4M6.003 5.125A3 3 0 0 0 6.401 6.5m-2.924 4.396a4 4 0 0 1 .585-.396M6 18a4 4 0 0 1-1.967-.516M12 13h4m-4 5h6a2 2 0 0 1 2 2v1M12 8h8m-4 0V5a2 2 0 0 1 2-2"></path>
                  <circle cx="16" cy="13" r=".5"></circle>
                  <circle cx="18" cy="3" r=".5"></circle>
                  <circle cx="20" cy="21" r=".5"></circle>
                  <circle cx="20" cy="8" r=".5"></circle>
                </svg>
              </div>
              <h3 className="section-subtitle">AI FAQ</h3>
              <p className="section-content">
                Learn how our AI works and how we keep your academic data safe
                and private.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Read FAQ</span>
                </div>
              </a>
            </div>
            <div className="resource-item cta-box">
              <h3 className="section-subtitle">Start Free Trial</h3>
              <p className="section-content">
                Get 7 days of unlimited syllabus uploads and AI features for
                free.
              </p>
              <button className="btn btn-primary">Try Now</button>
            </div>
            <div className="resource-item cta-box">
              <h3 className="section-subtitle">Connect Account</h3>
              <p className="section-content">
                Sync your Canvas, Blackboard, or Google Classroom account
                instantly.
              </p>
              <button className="btn btn-secondary">Connect LMS</button>
            </div>
            <div className="resource-item cta-box">
              <h3 className="section-subtitle">Refer a Friend</h3>
              <p className="section-content">
                Invite a classmate and both get 1 month of SylliPlan Premium
                free.
              </p>
              <button className="btn btn-accent">Invite Classmate</button>
            </div>
          </div>
        </div>
      </section>
      <div className="ai-study-helper-container8">
        <div className="ai-study-helper-container9">
          <Script
            html={`<script defer data-name="ai-study-helper">
(function(){
  const scrollContainer = document.querySelector(".timeline-scroll-container")
  let isDown = false
  let startX
  let scrollLeft

  if (scrollContainer) {
    scrollContainer.addEventListener("mousedown", (e) => {
      isDown = true
      scrollContainer.classList.add("active")
      startX = e.pageX - scrollContainer.offsetLeft
      scrollLeft = scrollContainer.scrollLeft
    })

    scrollContainer.addEventListener("mouseleave", () => {
      isDown = false
      scrollContainer.classList.remove("active")
    })

    scrollContainer.addEventListener("mouseup", () => {
      isDown = false
      scrollContainer.classList.remove("active")
    })

    scrollContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - scrollContainer.offsetLeft
      const walk = (x - startX) * 2
      scrollContainer.scrollLeft = scrollLeft - walk
    })
  }

  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  document.querySelectorAll(".feature-card, .testimonial-card, .resource-item, .step-item").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"
    observer.observe(el)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AIStudyHelper
